import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonButton, IonContent, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  arrowBackOutline,
  lockClosedOutline,
  logOutOutline,
} from 'ionicons/icons';
import { CommonRoute } from '../../../../../common/enums/common-route.enum';
import { PlatformService } from '../../../../../common/services/platform/platform.service';
import { ReturnUrlService } from '../../../../../common/services/return-url/return-url.service';
import { ComponentAccess } from '../../../../../common/decorators/component-access.decorator';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [IonContent, IonButton, IonIcon],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss',
})
@ComponentAccess('AccessDeniedComponent')
export class AccessDeniedComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private readonly returnUrlService = inject(ReturnUrlService);
  private readonly platformService = inject(PlatformService);

  requestedUrl: string | null = null;

  constructor() {
    addIcons({ lockClosedOutline, arrowBackOutline, logOutOutline });
    // Get the returnUrl from query params (set by the guard)
    this.requestedUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  logout() {
    this.router.navigate([CommonRoute.LOGOUT]);
  }

  goBack() {
    const win = this.platformService.getWindow();
    if (win && win.history.length > 1) {
      this.location.back();
    } else {
      // If there's no history, fallback to login with returnUrl
      this.router.navigate([CommonRoute.LOGIN], {
        queryParams: {
          returnUrl: this.returnUrlService.getSanitizedReturnUrl(
            this.requestedUrl ?? CommonRoute.HOME,
          ),
        },
      });
    }
  }
}
